var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsersIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 29,
    viewBox: "0 0 26 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6666 18.0033V20.79C12.4599 20.3633 11.1683 20.2325 9.90052 20.4084C8.63269 20.5843 7.42558 21.0618 6.38055 21.8009C5.33553 22.54 4.4831 23.5191 3.89486 24.6559C3.30662 25.7927 2.99974 27.054 2.99998 28.334L0.333313 28.3326C0.3329 26.7045 0.705208 25.0979 1.42171 23.6358C2.13821 22.1738 3.1799 20.8952 4.46694 19.898C5.75398 18.9008 7.25221 18.2115 8.84685 17.8828C10.4415 17.5542 12.0902 17.5949 13.6666 18.002V18.0033ZM11 16.334C6.57998 16.334 2.99998 12.754 2.99998 8.33398C2.99998 3.91398 6.57998 0.333984 11 0.333984C15.42 0.333984 19 3.91398 19 8.33398C19 12.754 15.42 16.334 11 16.334ZM11 13.6673C13.9466 13.6673 16.3333 11.2807 16.3333 8.33398C16.3333 5.38732 13.9466 3.00065 11 3.00065C8.05331 3.00065 5.66665 5.38732 5.66665 8.33398C5.66665 11.2807 8.05331 13.6673 11 13.6673ZM20.8906 21.6673H25.672V24.334H20.8906L23.3293 26.7713L21.444 28.658L15.7866 23.0007L21.444 17.3433L23.3293 19.23L20.8906 21.6673Z",
    fill: "#98A2B3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersIcon);
export default __webpack_public_path__ + "static/media/usersIcon.ce738204c2d439f37cc9989248814fc3.svg";
export { ForwardRef as ReactComponent };